"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RECEPTION_VOUCHERS_LINK = "/ostetut-vastaanottolipukkeet";
var PICKUP_VOUCHERS_LINK = "/ostetut-noutolipukkeet";

var VouchersTypeSwitch = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VouchersTypeSwitch, _Component);

  function VouchersTypeSwitch(props) {
    (0, _classCallCheck3.default)(this, VouchersTypeSwitch);
    return (0, _possibleConstructorReturn3.default)(this, (VouchersTypeSwitch.__proto__ || (0, _getPrototypeOf2.default)(VouchersTypeSwitch)).call(this, props));
  }

  (0, _createClass3.default)(VouchersTypeSwitch, [{
    key: "isPathActive",
    value: function isPathActive(path) {
      return this.props.pathname.indexOf(path) > -1;
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "voucher-order-type-switch" },
        _react2.default.createElement(
          _reactRouter.Link,
          {
            to: RECEPTION_VOUCHERS_LINK,
            className: "voucher-order-type " + (this.isPathActive(RECEPTION_VOUCHERS_LINK) ? "active" : "")
          },
          "Vastaanottolipukkeet"
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          {
            to: PICKUP_VOUCHERS_LINK,
            className: "voucher-order-type " + (this.isPathActive(PICKUP_VOUCHERS_LINK) ? "active" : "")
          },
          "Noutolipukkeet"
        )
      );
    }
  }]);
  return VouchersTypeSwitch;
}(_react.Component), _class.propTypes = {
  pathname: _react.PropTypes.string.isRequired
}, _temp);
exports.default = VouchersTypeSwitch;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/uservouchers/VoucherTypeSwitch.js
 ** module id = 485
 ** module chunks = 0
 **/